import { render, staticRenderFns } from "./OrderFormDialog.vue?vue&type=template&id=157bc97c&scoped=true"
import script from "./OrderFormDialog.vue?vue&type=script&lang=js"
export * from "./OrderFormDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderFormDialog.vue?vue&type=style&index=0&id=157bc97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157bc97c",
  null
  
)

export default component.exports